export interface Roles {
  id: RoleId;
  name: string;
  description: string;
}

export enum RoleId {
  Admin = 0,
  Trader = 1,
  RiskManager = 2,
  Viewer = 3,
  BlotterTrader = 5,
  BlotterAlgoTrader = 6,
  FixingOrderTrader = 7,
}

export type RoleMap = Record<string, RoleId[]>;
